import { useQueryParam, StringParam } from "use-query-params";

export const useYear = () => {
  const [year, setYear] = useQueryParam("year", StringParam);
  //@ts-ignore
  return [year, setYear] as const;
};
